(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    

  if (!customElements.get('vj-shipping-countdown')) {
    customElements.define('vj-shipping-countdown', class extends HTMLElement {
      connectedCallback() {
        if (this.countdownInterval) return;
        this.clockFormatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit',
          minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
        this.updateCountdown();
        this.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      updateCountdown() {
        const title = this.querySelector('[data-dispatch-title]');
        const description = this.querySelector('[data-dispatch-description]');
        const countdown = this.querySelector('[data-dispatch-countdown]');
        if (!title || !description || !countdown) return;
        const parts = Object.fromEntries(this.clockFormatter.formatToParts(new Date()).map(part => [part.type, part.value]));
        const secondsLeft = 17 * 3600 - (Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second));
        const isSunday = parts.weekday === 'Sun';
        const isOpen = !isSunday && secondsLeft > 0;
        const nextState = isOpen ? 'open' : 'closed';
        const nextTitle = isOpen ? this.dataset.today : (isSunday || parts.weekday === 'Sat' ? this.dataset.monday : this.dataset.tomorrow);
        const nextDescription = isOpen ? this.dataset.before : (isSunday ? this.dataset.weekend : this.dataset.after);
        if (title.textContent !== nextTitle) title.textContent = nextTitle;
        if (description.textContent !== nextDescription) description.textContent = nextDescription;
        this.dataset.state = nextState;
        countdown.hidden = !isOpen;
        if (!isOpen) return;
        const values = {
          hours: Math.floor(secondsLeft / 3600),
          minutes: Math.floor(secondsLeft % 3600 / 60),
          seconds: secondsLeft % 60
        };
        Object.entries(values).forEach(([unit, value]) => {
          const element = this.querySelector('[data-dispatch-' + unit + ']');
          const text = String(value).padStart(2, '0');
          if (element && element.textContent !== text) element.textContent = text;
        });
      }
    });
  }

if (!customElements.get('vj-cart-shipping')) {
  customElements.define('vj-cart-shipping', class extends HTMLElement {
    connectedCallback() {
      if (this.onCartUpdated) return;
      this.onCartUpdated = event => {
        const cart = event.detail && event.detail.cart;
        if (cart && Number.isFinite(cart.items_subtotal_price)) this.renderCart(cart);
      };
      document.addEventListener('cart:updated', this.onCartUpdated);
    }
    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
      this.onCartUpdated = null;
    }
    renderCart(cart) {
      const threshold = Number(this.dataset.threshold);
      const subtotal = Math.max(0, cart.items_subtotal_price);
      const remaining = Math.max(0, threshold - subtotal);
      const progress = Math.min(100, Math.round(subtotal / threshold * 100));
      const complete = remaining === 0;
      this.dataset.complete = String(complete);
      this.querySelectorAll('[data-shipping-complete]').forEach(el => { el.hidden = !complete; });
      this.querySelectorAll('[data-shipping-pending]').forEach(el => { el.hidden = complete; });
      this.querySelector('[data-shipping-remaining]').textContent = new Intl.NumberFormat(this.dataset.locale || 'nl', { style:'currency', currency:cart.currency || this.dataset.currency || 'EUR' }).format(remaining / 100);
      this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(progress));
      this.querySelector('.vj-shipping__fill').style.width = progress + '%';
      const count = document.querySelector('[data-vj-cart-count]');
      if (count) count.textContent = String(cart.item_count);
      const eco = document.querySelector('.vj-eco-wrap');
      const ratesElement = document.querySelector('[data-vj-co2-rates]');
      if (eco && ratesElement && Array.isArray(cart.items)) {
        try {
          const rates = JSON.parse(ratesElement.textContent);
          const completeRates = cart.items.every(item => Object.hasOwn(rates, String(item.variant_id)));
          const saving = cart.items.reduce((total, item) => total + (rates[String(item.variant_id)] || 0) * item.quantity, 0);
          eco.hidden = !completeRates || saving <= 0;
          const number = eco.querySelector('#cart-co2-besparing');
          if (number) number.textContent = new Intl.NumberFormat(this.dataset.locale || 'nl', {maximumFractionDigits:2}).format(saving);
        } catch (_) { eco.hidden = true; }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vj-app-download-popup"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    if(customElements.get('vj-app-download'))return;
    class VJAppDownload extends HTMLElement{
      connectedCallback(){
        this.sheet=this.querySelector('.vj-download-sheet');
        if(!this.sheet)return;
        this.controller=new AbortController();
        const opts={signal:this.controller.signal};
        this.mobile=matchMedia('(max-width:749px)');
        this.started=Date.now();
        this.readyAt=this.started+Math.max(15,Number(this.dataset.delay)||35)*1000;
        this.key='vj-app-invite-until-v1';
        this.sessionKey='vj-app-invite-seen-v1';
        this.until=0;this.seen=false;
        try{this.until=Number(localStorage.getItem(this.key))||0;this.seen=sessionStorage.getItem(this.sessionKey)==='1';}catch{}
        const ua=navigator.userAgent;
        this.dataset.platform=/android/i.test(ua)?'android':/iPhone|iPad|iPod/i.test(ua)?'apple':'both';
        this.inApp=/OneMobile|VersteeghJeans|; wv\)|FBAN|FBAV|Instagram/i.test(ua)||!!window.ReactNativeWebView||navigator.standalone===true||matchMedia('(display-mode:standalone)').matches;
        this.querySelectorAll('[data-app-dismiss]').forEach(b=>b.addEventListener('click',()=>this.dismiss(Number(this.dataset.dismissDays)||7),opts));
        this.querySelector('[data-app-installed]').addEventListener('click',()=>this.dismiss(180),opts);
        this.querySelectorAll('[data-app-store]').forEach(a=>a.addEventListener('click',()=>this.dismiss(30),opts));
        document.addEventListener('click',e=>{
          const target=e.target instanceof Element?e.target:null;
          const trigger=target?.closest('[data-vj-app-open]');
          if(trigger&&this.mobile.matches&&!this.inApp){this.opener=trigger;this.open(true);return;}
          if(target?.closest('form[action*="/cart"],.product-form,[name="add"],[name="checkout"],.js-drawer-open-cart,.shopify-payment-button,.product__submit')){this.readyAt=Date.now()+60000;if(!this.sheet.hidden)this.dismiss(7);}
        },opts);
        document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!this.sheet.hidden)this.dismiss(Number(this.dataset.dismissDays)||7);},opts);
        this.mobile.addEventListener('change',()=>{this.updateTriggers();if(!this.mobile.matches){this.sheet.hidden=true;document.body.classList.remove('vj-app-invite-open');}},opts);
        this.updateTriggers();
        this.timer=setInterval(()=>this.maybeOpen(),2500);
        document.addEventListener('shopify:section:select',e=>{if(e.detail?.sectionId===this.dataset.section&&window.Shopify?.designMode)this.open(true);},opts);
      }
      updateTriggers(){document.querySelectorAll('[data-vj-app-open]').forEach(b=>b.hidden=!this.mobile.matches||this.inApp);}
      remember(days){
        this.seen=true;this.until=Date.now()+days*86400000;
        try{sessionStorage.setItem(this.sessionKey,'1');localStorage.setItem(this.key,String(this.until));}catch{}
      }
      blocked(){
        if(document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[aria-expanded="true"]'))return true;
        if(document.activeElement?.matches('input,select,textarea,[contenteditable="true"]'))return true;
        if(document.documentElement.classList.contains('js-drawer-open')||document.body.classList.contains('modal-open'))return true;
        return [...document.querySelectorAll('dialog[open],[aria-modal="true"],.modal--is-active,.drawer--is-open,.pswp--open,#shopify-pc__banner,#shopify-pc__prefs')].some(el=>{const box=el.getBoundingClientRect();return box.width>0&&box.height>0&&getComputedStyle(el).visibility!=='hidden'&&el.getAttribute('aria-hidden')!=='true';});
      }
      maybeOpen(){
        if(this.seen||this.until>Date.now()||this.inApp||window.Shopify?.designMode){clearInterval(this.timer);return;}
        if(!this.mobile.matches||document.visibilityState!=='visible'||Date.now()<this.readyAt||this.blocked())return;
        if(scrollY<Math.min(600,innerHeight*.75))return;
        this.open(false);
      }
      open(manual){
        if(!this.mobile.matches||this.inApp||this.blocked())return;
        this.querySelectorAll('img[data-src]').forEach(img=>{img.src=img.dataset.src;delete img.dataset.src;});
        this.sheet.hidden=false;document.body.classList.add('vj-app-invite-open');this.remember(Number(this.dataset.dismissDays)||7);clearInterval(this.timer);
        if(manual)this.querySelector('[data-app-dismiss]').focus({preventScroll:true});
      }
      dismiss(days){
        const restore=this.sheet.contains(document.activeElement);
        this.sheet.hidden=true;document.body.classList.remove('vj-app-invite-open');this.remember(days);clearInterval(this.timer);
        if(restore&&this.opener?.isConnected)this.opener.focus({preventScroll:true});
      }
      disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();document.body.classList.remove('vj-app-invite-open');}
    }
    customElements.define('vj-app-download',VJAppDownload);
  })();

  } catch(e) { console.error(e); }
})();
})();
